import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './WhatsappWidget.module.css';
import WhatsappPopup from './WhatsappPopup';

const WhatsappWidget = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [whatsappLink, setWhatsappLink] = useState('');
    const location = useLocation();

    useEffect(() => {
        const links = {
            '/': 'https://api.whatsapp.com/send?phone=+918826030828&text=Hello! I am planning to travel. Can you help me with some more info?',
            '/trip': 'https://api.whatsapp.com/send?phone=+919999352031&text=Hello! I would like to know more about the trips being hosted.'
        };
        // if (location.pathname.startsWith('/trip')) setWhatsappLink(links['/trip']);
        // else setWhatsappLink(links['/']);
        setWhatsappLink(links[location.pathname] || links['/']);
    }, [location.pathname, isVisible]);

    return (
        <>
            <div
                className="whatsapp-chat-icon"
                onClick={() => {setIsVisible(!isVisible);}}
            >
                {/* <a href={whatsappLink} target='_blank' rel='noopener noreferrer'> */}
                    <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" />
                {/* </a> */}
            </div>

            {isVisible && (
                <>
                <WhatsappPopup setIsVisible={setIsVisible} whatsappLink={whatsappLink} />
                </>
            )}
        </>
    );
};

export default WhatsappWidget;
